// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7b14c9af","239":"3f8dab88","453":"f4d7e28d","732":"37c19efe"}[chunkId] + ".chunk.js";
};